import { createStore } from 'vuex'

import analyticsData from './modules/analytics-data'
import research from './modules/research'
import review from './modules/review'
import archive from './modules/archive'
import pressRelease from './modules/press-release'
import smiAboutUs from './modules/smi-about-us'
import report from './modules/report'
import subscribe from './modules/subscribe'
import search from './modules/search/search'
import topCategories from './modules/search/top-categories'
import news from './modules/for-business/izhs/news'
import events from './modules/for-business/izhs/events'
import izhsArchive from './modules/for-business/izhs/archive'
import rsp from './modules/rsp'
import vacanciesFilters from './modules/vacancies/filters.js'
import vacanciesList from './modules/vacancies/list.js'

export default createStore({
	state: {},
	getters: {},
	mutations: {},
	actions: {},
	modules: {
		analyticsData,
		research,
		archive,
		pressRelease,
		smiAboutUs,
		report,
		review,
		subscribe,
		search,
		topCategories,
		news,
		events,
		izhsArchive,
		rsp,
		vacanciesFilters,
		vacanciesList,
	},
})
